import { useMappedState } from "redux-react-hook";
import * as React from "react";

import { useDrop } from "src/core/drops/hooks";

import { IStore } from "../../shared/store";

export const usePriceVisibility = (): boolean => {
  const [ { drop } ] = useDrop();
  const { role } = useMappedState((store: IStore) => ({ role: store.global.role }));

  return React.useMemo(() => {
  // show for admins
    if (role?.type === "admin") {
      return true;
    }

    if (!drop) {
      return false;
    }

    const { groupedSettings } = drop;

    if (groupedSettings) {
      const { price_visible } = groupedSettings;

      if (price_visible) {
        return price_visible.value.visible;
      } else {
        return true;
      }
    }

    return true;
  }, [ drop, role?.type ]);
};
